const normalizePath = (path: string): string =>
  path.replace(/^\/+/, '').replace(/\/+$/, '');

export default normalizePath;
